// Simple CEP service using ViaCEP public API
export async function fetchAddressByCep(cep) {
  const cleaned = cep.replace(/\D/g, "");
  if (cleaned.length !== 8) {
    throw new Error("CEP inválido");
  }
  const url = `https://viacep.com.br/ws/${cleaned}/json/`;
  const res = await fetch(url);
  if (!res.ok) throw new Error("Falha ao buscar CEP");
  const data = await res.json();
  if (data.erro) throw new Error("CEP não encontrado");
  return {
    cep: data.cep,
    state: data.uf,
    city: data.localidade,
    neighborhood: data.bairro,
    street: data.logradouro,
    complement: data.complemento || "",
  };
}// services/cepService.js
export async function buscarCEP(cepRaw) {
  if (!cepRaw) throw new Error('Informe o CEP.');
  // Limpa o CEP para só dígitos
  const cep = String(cepRaw).replace(/\D/g, '');
  if (cep.length !== 8) throw new Error('CEP inválido. Deve ter 8 dígitos.');

  const url = `https://viacep.com.br/ws/${cep}/json/`;
  const res = await fetch(url, { method: 'GET' });

  if (!res.ok) {
    throw new Error('Erro ao consultar o serviço de CEP.');
  }

  const data = await res.json();

  if (data.erro) {
    throw new Error('CEP não encontrado.');
  }

  // Retorna os campos úteis do ViaCEP
  return {
    cep: data.cep || '',
    logradouro: data.logradouro || '',     // rua
    complemento: data.complemento || '',
    bairro: data.bairro || '',
    localidade: data.localidade || '',     // cidade
    uf: data.uf || '',                     // estado
    unidade: data.unidade || '',
    ibge: data.ibge || '',
  };
}
